import { MantineForm } from '../AddEditMatterForm';
import { SelectOption } from '../../types';
import SelectField from './SelectField';

interface PracticeAreaSelectProps {
  form: MantineForm;
  practiceAreaOptions: SelectOption[];
}

const PracticeAreaSelect: React.FC<PracticeAreaSelectProps> = ({
  form,
  practiceAreaOptions,
}) => {
  return (
    <SelectField
      fieldName='practiceAreaId'
      label='Practice Area'
      options={practiceAreaOptions}
      form={form}
    />
  );
};

export default PracticeAreaSelect;
